import * as HccFinding from './models/hccFinding';

import { Common } from './common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  // analyst app endpoints
  async findHccFindingsToExportByEncounterId(
    encounterId: string,
  ): Promise<HccFinding.HccFinding[]> {
    const url = this.common.constructPath(`/hcc-findings/findings-to-export`, {
      encounterId,
    });
    return this.common.getJSON(url);
  }
}
